<template>
<div class="container">
    <div class="columns current-page-container">
        <div class="column is-one-fifth">
            <h1 :class="current.alias">
                <svg xmlns="http://www.w3.org/2000/svg" width="35" height="44" viewBox="0 0 34.9 43.7" :class="current.alias">
                    <!-- eslint-disable-next-line -->
                    <path class="st1" d="M34.5 41.9c-4.4-0.9-7.7-3.3-10.6-6.3 -3-3-4.9-6.7-6.4-11 -0.3 0.7-0.5 1.2-0.7 1.7 -2.1 5.3-5.4 9.7-10.2 13 -1.6 1.1-3.4 1.9-5.3 2.4 -0.3 0.1-0.6 0.1-0.8 0.1 -0.3-0.8 0.1-1 0.6-1.3 1.4-0.9 2.8-1.7 4.1-2.7 6.1-4.5 9.4-10.7 10.9-18 0.2-1.2 0-2.4 0-3.7 0-1.2 0.1-2.3 0.1-3.5 0-0.8 0-1.6 0-2.6 0.8-0.7 1.7-0.7 2.6 0 0 3 0 5.9 0 8.9 0 0.8 0.2 1.6 0.4 2.4 2.1 8.2 6.6 14.6 14.1 18.7C33.8 40.5 34.7 40.6 34.5 41.9z"
                    />
                    <!-- eslint-disable-next-line -->
                    <path class="st0" d="M17.4 24c-6.5 0-11.7-5.3-11.7-11.7 0-6.5 5.3-11.8 11.7-11.8 6.5 0 11.7 5.3 11.7 11.8C29.2 18.8 23.9 24 17.4 24zM17.4 2.3c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C27.4 6.8 22.9 2.3 17.4 2.3z"
                    />
                </svg>
                {{current.label}}
            </h1>
        </div>
        <div class="column is-four-fifths" v-html="content">
        </div>
    </div>

    <h2 class="section-header">סדרות אימונים</h2>

     <group-videos :items="currentGvs"></group-videos>

    <h2 class="section-header">שיעורים נבחרים</h2>

    <videos :videos="videos.slice(0,4)"></videos>

    <div class="columns">
      <div class="column current-videos">
        <router-link :to="{name: 'currentVideos'}" class="yoga-btn-purple">
          לכל השיעורים
        </router-link>
      </div>
    </div>

    <h2 class="section-header">מורים</h2>

    <current-teachers :teachers="currentTeachers"></current-teachers>

</div>

</template>

<script>
import GroupVideos from "@/components/series/GroupVideos.vue";
import Videos from "@/components/Videos.vue";
import CurrentTeachers from "@/components/currents/CurrentTeachers.vue";

export default {
  name: `CurrentPage`,

  data() {
    return {
      content: ``
    };
  },

  components: {
    Videos,
    GroupVideos,
    CurrentTeachers
  },

  beforeRouteEnter(to, from, next) {
    window.scrollTo(0, 0);
    next((vm) => {
      vm.setContent();
    });
  },

  beforeRouteUpdate(to, from, next) {
    window.scrollTo(0, 0);
    this.setContent();
    next();
  },

  watch: {
    current() {
      this.setContent();
    }
  },

  computed: {
    videoList() {
      return this.$store.state.videos;
    },

    current() {
      let output = {};
      if (Array.isArray(this.$store.state.initialData.currents)) {
        const cur = this.$store.state.initialData.currents.filter((c) => {
          if (c.id === this.$route.params.cid) {
            return true;
          }
          return false;
        });
        output = cur[0];
      }
      return output;
    },
    videos() {
      let cur = [];
      if (Array.isArray(this.videoList)) {
        cur = this.videoList.filter((v) => {
          if (v.current === this.current.resource.id) {
            return true;
          }
          return false;
        });
      }
      return cur;
    },

    currentGvs() {
      let gvs = [];
      if (Array.isArray(this.$store.state.series)) {
        gvs = this.$store.state.series.filter((s) => {
          if (s.tag[0].tag === this.$route.params.cid && s.parent === `10`) {
            return true;
          }
          return false;
        });
      }
      return gvs;
    },
    currentTeachers() {
      const teachers = [];
      if (Array.isArray(this.$store.state.initialData.teachers)) {
        this.$store.state.initialData.teachers.forEach((t) => {
          t.currents.forEach((c) => {
            if (c.tag === this.current.id) {
              teachers.push(t);
            }
          });
        });
      }
      return teachers;
    },

    isLoggedIn() {
      return this.$store.state.user.isLoggedIn;
    }
  },

  methods: {
    setContent() {
      if (typeof this.current.resource !== `undefined`) {
        this.content = this.current.resource.content;
      }
    }
  }

  // created() {
  //   if (this.isLoggedIn === 0) {
  //     this.$router.push(`/profile`);
  //   }
  // },
};
</script>

<style lang="scss">
.current-page-container {
  padding-top: 20px;
  h1 {
    text-align: center;
    float: right;
    svg {
      display: block;
      margin: 0 auto;
      width: 60px;
      height: 60px;
    }
  }
}

.current-videos {
  text-align: center;

  .yoga-btn-purple {
    margin: 10px;
  }
}
</style>
